import React from 'react';

const Header =()=>{
    return (
        <div>
            <h1><i className="icon-col fab fa-cloudsmith"></i> Cloud Connect Features</h1>
        </div>
    )
};

export default Header;